export class VendorDto {
  vendorId: string;
  vendorName?: string;
  isActive: boolean;
}
